import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { getCachedSignedUrl } from '@mcn-platform/models';
import Image from './Image';
const SignedImage = ({ bucket, bucketKey, status, alt, className, avatar, avatarVariant, customStyle, backgroundColor, fallbackSrc, updatedAt, }) => {
    const [url, setUrl] = useState();
    useEffect(() => {
        if (!bucket || !bucketKey) {
            setUrl('');
            return;
        }
        getCachedSignedUrl(bucket, bucketKey).then((val) => {
            setUrl(val);
        });
    }, [bucket, bucketKey, fallbackSrc, status, updatedAt]);
    if (!url) {
        return null;
    }
    return (_jsx(Image, { url: url, status: "", alt: "", className: className, avatar: avatar, avatarVariant: avatarVariant, customStyle: customStyle, fallbackSrc: fallbackSrc }));
};
SignedImage.defaultProps = {
    className: '',
    avatar: false,
    customStyle: {},
    avatarVariant: 'circular',
    backgroundColor: '#444444',
    fallbackSrc: undefined,
    updatedAt: undefined,
};
export default observer(SignedImage);
//# sourceMappingURL=SignedImage.js.map